import React from 'react';
import {withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';

import logo from '../../assets/img/logo.svg';
import downArr from '../../assets/img/down-arr.svg';
import { SamplesActions } from './../../actions';

class DesktopHeader extends React.Component {

    renderHeaderLinks = () => {
        const {langUrl,langTxt,pageName} = this.props;
        const headerLinks = [
            {
                title: "Collections",
                link:langUrl+"/collections"
            },
            {
                title: "Blog",
                link:langUrl+"/blog"
            },
            {
                title: "About",
                link:langUrl+"/about"
            }
        ]

        return headerLinks.map(({title,link},i)=>{
            const activeClass = (link === pageName)? "header-link-active" : '';
            return <Link to={link} key={"link-title-" + i} className={activeClass}>{title}</Link>
        })
    }
    render (){
        const {langTxt, langUrl, samplesopened, samplesCount} = this.props;
        const openedClass = samplesopened? 'samples-opened' : '';
        const headerOpen = samplesopened? 'white-bg' : '';
       return (
            <div className={"desktop-header " + headerOpen}>
                <Link to={langUrl}>
                    <img src={logo} alt="logo"/>
                </Link>
                <div className={"my-samples cursor-pointer " + openedClass} onClick={()=>this.props.openSamples(!samplesopened)}>
                    <p>My Samples</p>
                    <div className="menu-open-btn">
                        <p>{samplesCount}</p>
                        <img src={downArr} alt="down-arr"/>
                    </div>
                </div>
                <div className="nav-bar">
                    {this.renderHeaderLinks()}
                </div>
                {(langTxt === "en")? <a className="cursor-pointer lang-btn" href="/fr">Fr</a>: <a className="cursor-pointer lang-btn" href="/">En</a>}
            </div>
       );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        samplesCount: (state.samples && state.samples.list)? state.samples.list.length : 0,
        samplesopened: (state.samples && state.samples.opened),
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
        pageName: (state.page && state.page.name) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
        openSamples: (isOpened) => dispatch(SamplesActions.open(isOpened))
    };
};
export default withRouter( connect(mapStateToProps, mapDispatchToProps)(DesktopHeader) );